"use client";
import Image from "@/node_modules/next/image";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import { useRouter } from "next/navigation";
import Franchise from "../../assets/salon_frenchise.jpg";
import { Loader } from "../genericComponents/MainLoader/Loader";
import "./index.css";

interface InstructionProps {
  UrlLinks: any;
}

export const Instruction: React.FC<InstructionProps> = ({ UrlLinks }) => {
  const [loader, setLoader] = useState(false);
  const router = useRouter();

  const handleNaviagte = (e: any) => {
    e.preventDefault();
    setLoader(true);
    router.push("/contact-franchise");
  };
  return (
    <>
      {loader && <Loader />}
      {UrlLinks?.length > 1 && (
        <Box
          className="instruction-container"
          sx={{
            display: "-webkit-inline-box",
            justifyContent: "start",
            alignItems: "center",
            overflowX: "scroll",
            width: "100%",
            margin: "auto",
            backgroundColor: "white",
            borderColor: "none",
          }}
        >
          {UrlLinks?.map((item: any, i: number) => (
            <Image
              key={i}
              className="instruction-card"
              src={item?.webImage?.secureHttpPath}
              width={500}
              height={500}
              alt="Banner Image"
            />
          ))}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // background: "#46623c",
          cursor: "pointer",
        }}
        onClick={handleNaviagte}
      >
        <Image
          src={Franchise}
          width={2000}
          height={1000}
          alt="Banner Image"
          className="franchise-image"
        />
      </Box>
    </>
  );
};
